import { useEffect, useRef, useState } from "react";
import { useInView } from "../hooks/useInView";

const Counter = ({ end, suffix = "", duration = 1600, className }) => {
  const { ref, inView } = useInView({ threshold: 0.4 });
  const [value, setValue] = useState(0);
  const raf = useRef();

  useEffect(() => {
    if (!inView) return;

    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(eased * end));
      if (progress < 1) raf.current = requestAnimationFrame(tick);
    };

    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [inView, end, duration]);

  return (
    <span ref={ref} className={className}>
      {value}
      {suffix}
    </span>
  );
};

export default Counter;